import React from 'react'
import { Grid, Paper, TextField, Button, InputAdornment, makeStyles, useTheme, useMediaQuery } from '@material-ui/core'
import SearchIcon from '@material-ui/icons/Search'
import ExportMenu from './ExportMenu'
import AddIcon from '@material-ui/icons/Add';
import KeyboardArrowDownIcon from "@material-ui/icons/KeyboardArrowDown";
import FilterComponent from '../../shared_elements/components/filter_component';
const useStyles = makeStyles((theme) => ({
	paper: {
		padding: theme.spacing(0.8, 1.2),
		marginBottom: theme.spacing(1),
		boxShadow: 'none',
	},
	root: {
		width: '100%',
	},
	searchGrid: {
		[theme.breakpoints.down('xs')]: {
			marginBottom: theme.spacing(1),
		},
	},
	searchField: {
		'& .MuiOutlinedInput-root': {
			fontSize: 12,
			[theme.breakpoints.down('xs')]: {
				fontSize: 13,
			},
		},
	},
	actionsGrid: {
		display: 'flex',
		alignItems: 'center',
		[theme.breakpoints.down('xs')]: {
			justifyContent: 'center',
		},
		[theme.breakpoints.up('sm')]: {
			justifyContent: 'flex-end',
		},
	},
	actionsList: {
		display: 'flex',
		flexWrap: 'wrap',
		gap: 6,
		margin: 0,
		padding: 0,
		listStyle: 'none',
		[theme.breakpoints.down('xs')]: {
			justifyContent: 'center',
			width: '100%',
		},
		[theme.breakpoints.between('sm', 'md')]: {
			justifyContent: 'flex-end',
		},
		[theme.breakpoints.up('md')]: {
			justifyContent: 'flex-end',
		},
	},
	actionItem: {
		[theme.breakpoints.down('xs')]: {
			flexGrow: 1,
			minWidth: 'calc(50% - 6px)',
			maxWidth: 'calc(50% - 6px)',
			'& button, & > div': {
				width: '100%',
			},
		},
		[theme.breakpoints.between('sm', 'sm')]: {
			flexShrink: 0,
		},
		[theme.breakpoints.up('md')]: {
			flexShrink: 0,
		},
	},
}))


const FleetCTA = ({ searchPlaceholder, onSearch, permissionCheck, addLabel, onAddFn, onImportFn, exportMenu, downloadSampleMenu, filterObj, filterOptions, getResponseBack }) => {
	const classes = useStyles()
	const theme = useTheme()
	const isMobile = useMediaQuery(theme.breakpoints.down('xs'))

	return (
		<Paper
			variant='outlined'
			className={classes.paper}
			square
		>
			<Grid container spacing={1} className={classes.root} alignItems='center'>
				<Grid item md={3} sm={12} xs={12} className={classes.searchGrid}>
					<TextField
						variant='outlined'
						fullWidth
						size='small'
						placeholder={searchPlaceholder || 'Search'}
						className={classes.searchField}
						onChange={(e) => onSearch && onSearch(e.target.value)}
						InputProps={{
							style: { fontSize: 12 },
							endAdornment: (
								<InputAdornment position='end'>
									<SearchIcon color='primary' style={{ cursor: 'pointer' }} />
								</InputAdornment>
							),
						}}
					/>
				</Grid>
				<Grid item md={4} sm={6} xs={12} className={classes.searchGrid}>
					<div>
						<FilterComponent
							filter={filterObj}
							filterMenu={filterOptions}
							getResponseBack={getResponseBack}
						/>
					</div>
				</Grid>
				<Grid item md={5} sm={6} xs={12} className={classes.actionsGrid}>
					<ul className={classes.actionsList}>
						{!permissionCheck && downloadSampleMenu && (
							<li className={classes.actionItem}>
								<ExportMenu
									exportReportFn={downloadSampleMenu?.exportReportFn}
									files={downloadSampleMenu?.files}
									title={<>{isMobile ? 'SAMPLE' : 'DOWNLOAD SAMPLE'}<KeyboardArrowDownIcon style={{ marginTop: "-1px" }} /></>}
								/>
							</li>
						)}
						{exportMenu && (
							<li className={classes.actionItem}>
								<ExportMenu
									exportReportFn={exportMenu.exportReportFn}
									files={exportMenu?.files}
									disabled={exportMenu?.disabled}
									title={'EXPORT'}
								/>
							</li>
						)}
						{!permissionCheck && onImportFn && (
							<li className={classes.actionItem}>
								<Button fullWidth variant='outlined' color='primary' size='small' onClick={onImportFn}>
									<AddIcon style={{ fontSize: '1.15rem' }} /> IMPORT
								</Button>
							</li>
						)}
						{!permissionCheck && (
							<li className={classes.actionItem}>
								<Button fullWidth variant='contained' color='primary' size='small' onClick={onAddFn}>
									<AddIcon style={{ fontSize: '1.15rem' }} />{isMobile ? ('ADD') : (addLabel || 'ADD')}
								</Button>
							</li>
						)}
					</ul>
				</Grid>
			</Grid>
		</Paper>
	)
}

export default FleetCTA
